module.exports = __webpack_public_path__ + "img/3_fineStaff_cyy.4be61dd4.png";